import { BaseModel, type RelationConfig } from './base';

import { Customer } from './customer';
import { Order } from './order';
import { Pass } from './pass';
import { Reservation } from './reservation';

// Helper Classes

export class CustomerPassOptions extends BaseModel {
  passes!: Pass[];

  static override relations(): RelationConfig {
    return {
      passes: { type: Pass },
    };
  }
}

export class CustomerPassTransaction extends BaseModel {
  order!: Order | null;

  static override relations(): RelationConfig {
    return {
      order: { type: Order },
    };
  }
}

// Main Model

export class CustomerPass extends BaseModel {
  static modelName(): string {
    return 'customerPass'
  }

  idCustomerPass!: number;
  usesRemaining!: number;
  expiryDate!: string | null;
  gift!: any;
  customer!: Customer | null;
  options!: CustomerPassOptions | null;
  order!: Order | null;
  pass!: Pass | null;
  allReservations!: Reservation[];

  static override relations(): RelationConfig {
    return {
      customer: { type: Customer },
      options: { type: CustomerPassOptions },
      order: { type: Order },
      pass: { type: Pass },
      allReservations: { type: Reservation },
    };
  }

  override objectID(): string | null {
    return this.idCustomerPass?.toString() ?? null;
  }

  get isUnlimitedUse(): boolean {
    return this.usesRemaining === -1;
  }

  get isLimitedUse(): boolean {
    return this.usesRemaining !== -1;
  }

  get expires(): boolean {
    return !!this.expiryDate;
  }

  get neverExpires(): boolean {
    return !this.expiryDate;
  }

  get customerLabel(): string {
    if (this.isGift) {
      return `${this.gift?.to?.name} (${this.gift?.to?.email})`;
    }
    return this.customer?.displayName || '-';
  }

  get isGift(): boolean {
    return !!this.gift;
  }

  get isGiftDelivered(): boolean {
    return this.isGift && this.gift.delivered;
  }
}
